import { ResumoMedicaoList } from "@app/api/boletimMedicao";
import { atom } from "recoil";

export const medicaoIdState = atom({
  key: 'medicaoIdState',
  default: undefined,
});

export const medicaoSelectedState = atom({
  key: 'medicaoSelectedState',
  default: {} as ResumoMedicaoList,
});